import React, { useEffect, useMemo, useState } from 'react';
import { formatAnimatedValue, getAnimatedValueConfig } from '../../utils/analytics';

const AnalyticsCard = ({ title, body, icon, className = '' }) => {
  const cardClassName = ['analytics-card', className].filter(Boolean).join(' ');
  const animatedValueConfig = useMemo(() => getAnimatedValueConfig(body), [body]);
  const [displayValue, setDisplayValue] = useState(body);

  useEffect(() => {
    if (!animatedValueConfig.isNumeric) {
      setDisplayValue(body);
      return undefined;
    }

    let animationFrameId;
    const duration = 900;
    const startTime = performance.now();

    const animate = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      const currentValue = animatedValueConfig.value * easedProgress;

      setDisplayValue(formatAnimatedValue({
        ...animatedValueConfig,
        value: currentValue,
      }));

      if (progress < 1) {
        animationFrameId = requestAnimationFrame(animate);
      }
    };

    animationFrameId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationFrameId);
  }, [animatedValueConfig, body]);

  return (
    <section className={cardClassName}>
      {(icon || (title !== undefined && title !== null)) && (
        <div className="analytics-card__header">
          {icon && <span className="analytics-card__icon">{icon}</span>}
          {title !== undefined && title !== null && (
            <h3 className="analytics-card__title">{title}</h3>
          )}
        </div>
      )}
      {body !== undefined && body !== null && (
        <div className="analytics-card__body">{displayValue}</div>
      )}
    </section>
  );
};

export default AnalyticsCard;
